module.exports = __webpack_public_path__ + "img/treeplant4_7-8-2021.fe56e962.jpg";